import React from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "@mui/material";
import { formatCents } from "./zipSlotAdsHelpers";

const ZipSlotBoard = ({
  zip,
  board,
  loading = false,
  ownBid = null,
  onPlaceBid,
}) => {
  if (!zip) return null;

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="h6">
          Ranked slots for {zip}
        </Typography>
        <Button variant="contained" onClick={() => onPlaceBid()}>
          {ownBid ? "Update bid" : "Place bid"}
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Slot</TableCell>
              <TableCell>Bid to hold</TableCell>
              <TableCell>Occupancy</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(board || []).map((slot) => {
              const isOwn = slot.isOwn;
              return (
                <TableRow key={slot.rank} selected={isOwn}>
                  <TableCell>
                    <Typography fontWeight={isOwn ? 700 : 400}>
                      #{slot.rank}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {slot.filled ? formatCents(slot.bidPerClickCents) : "Open"}
                  </TableCell>
                  <TableCell>
                    {isOwn ? (
                      <Chip size="small" color="success" label="Your facility" />
                    ) : slot.filled ? (
                      <Typography variant="body2" color="text.secondary">
                        Occupied
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Open
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ZipSlotBoard;
